import p from "lodash-es/merge";
import T from "lodash-es/uniqueId";
import { ref as h, reactive as y, readonly as b } from "vue";
const w = 5e3, n = h([]);
function M(a = { timeout: w }) {
  function f(e) {
    const t = typeof e == "string" ? e : void 0, { group: i = void 0, status: r = void 0 } = typeof e == "object" ? e : {};
    if (!t && (!i || !r))
      throw new Error("Must provide either a toast ID or both group and type");
    const o = i && r ? `toast-${r}-${i}` : String(t), c = n.value.findIndex(({ id: l }) => l === o);
    c !== -1 && n.value.splice(c, 1);
  }
  function u(e, t, i) {
    const r = p({}, a, i), o = r != null && r.group ? `toast-${t}-${r.group}` : T("toast-");
    if (!(r != null && r.group && n.value.some(({ id: c }) => c === o)))
      return n.value.push({ text: e, id: o, status: t }), typeof r.timeout == "number" && setTimeout(() => f(o), Math.abs(r.timeout)), o;
  }
  function s() {
    n.value = [];
  }
  function m(e, t) {
    return u(e, "error", t);
  }
  function v(e, t) {
    return u(e, "info", t);
  }
  function d(e, t) {
    return u(e, "success", t);
  }
  function g(e, t) {
    return u(e, "warning", t);
  }
  return y({
    /**
     * The list of toasts that are currently visible.
     */
    active: b(n),
    /**
     * Removes an active/visible toast by id or by group and type.
     */
    remove: f,
    /**
     * Creates a new toast and makes it active/visible.
     */
    create: u,
    /**
     * Removes all active/visible toasts.
     */
    removeAll: s,
    /**
     * Creates a new "error" toast.
     */
    error: m,
    /**
     * Creates a new "info" toast.
     */
    info: v,
    /**
     * Creates a new "success" toast.
     */
    success: d,
    /**
     * Creates a new "warning" toast.
     */
    warning: g
  });
}
export {
  w as DEFAULT_TIMEOUT,
  M as default
};
//# sourceMappingURL=useToasts.js.map
